// src/components/ModalPixAntecipado.js
/**
 * Aparece para o passageiro quando a corrida muda para "in_progress"
 * e o método de pagamento é Pix.
 *
 * Opções:
 *   "Pagar agora"  → abre ModalPixCorrida (QR Code / chave)
 *   "Pagar ao final" → fecha sem fazer nada (pagamento normal no fim)
 */
import React, { useState } from "react";
import ModalPixCorrida from "./ModalPixCorrida";

export default function ModalPixAntecipado({
  motoristaNome,
  chavePix,
  qrCodeUrl,
  valorCorrida,
  onPagarAgora,   // callback de fechamento; não significa Pix confirmado
  onPagarFinal,   // callback quando escolhe pagar ao final
}) {
  const [showQr, setShowQr] = useState(false);

  const handlePagarAgora = () => {
    setShowQr(true);
  };

  const handleFecharQr = () => {
    setShowQr(false);
    // Avisa apenas que o passageiro visualizou o Pix. O recebimento só pode
    // ser confirmado pelo motorista/backend.
    onPagarAgora?.();
  };

  if (showQr) {
    return (
      <ModalPixCorrida
        chavePix={chavePix}
        qrCodeUrl={qrCodeUrl}
        valorCorrida={valorCorrida}
        motoristaNome={motoristaNome}
        onFechar={handleFecharQr}
      />
    );
  }

  return (
    <div style={{
      position: "fixed", inset: 0, zIndex: 99985,
      background: "rgba(0,0,0,0.70)",
      display: "flex", alignItems: "flex-end",
      fontFamily: "'Segoe UI', system-ui, sans-serif",
    }}>
      <style>{`@keyframes slideUpPix{from{opacity:0;transform:translateY(80px)}to{opacity:1;transform:translateY(0)}}`}</style>
      <div style={{
        width: "100%", maxWidth: 480, margin: "0 auto",
        background: "#0d1527",
        borderRadius: "24px 24px 0 0",
        padding: "24px 24px 44px",
        border: "1px solid rgba(6,182,212,0.25)",
        borderBottom: "none",
        animation: "slideUpPix 0.3s ease",
      }}>
        <div style={{ width: 36, height: 4, background: "rgba(255,255,255,0.15)", borderRadius: 2, margin: "0 auto 20px" }} />

        {/* Ícone + título */}
        <div style={{ textAlign: "center", marginBottom: 20 }}>
          <div style={{
            width: 64, height: 64, borderRadius: "50%",
            background: "rgba(6,182,212,0.1)",
            border: "2px solid rgba(6,182,212,0.4)",
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: 28, margin: "0 auto 14px",
          }}>
            📱
          </div>
          <p style={{ color: "#06b6d4", fontWeight: 800, fontSize: 18, margin: "0 0 6px" }}>
            Quer pagar o Pix agora?
          </p>
          <p style={{ color: "rgba(255,255,255,0.4)", fontSize: 13, margin: 0 }}>
            Corrida em andamento com {motoristaNome?.split(" ")[0] || "o motorista"}
          </p>
        </div>

        {/* Valor */}
        <div style={{
          background: "rgba(6,182,212,0.06)",
          border: "1px solid rgba(6,182,212,0.15)",
          borderRadius: 14, padding: "14px", textAlign: "center", marginBottom: 20,
        }}>
          <p style={{ color: "rgba(255,255,255,0.35)", fontSize: 11, letterSpacing: 1, margin: "0 0 4px", textTransform: "uppercase" }}>
            Valor da corrida
          </p>
          <p style={{ color: "#06b6d4", fontSize: 32, fontWeight: 800, margin: 0, letterSpacing: -1 }}>
            R$ {Number(valorCorrida || 0).toFixed(2)}
          </p>
        </div>

        {/* Botão: pagar agora */}
        <button
          onClick={handlePagarAgora}
          style={{
            width: "100%", padding: "15px",
            borderRadius: 14, border: "none",
            background: "linear-gradient(135deg,#0891b2,#06b6d4)",
            color: "#fff", fontSize: 15, fontWeight: 800,
            cursor: "pointer", fontFamily: "inherit",
            marginBottom: 10,
            boxShadow: "0 4px 20px rgba(6,182,212,0.35)",
          }}
        >
          📲 Pagar agora via Pix
        </button>

        {/* Botão: pagar ao final */}
        <button
          onClick={onPagarFinal}
          style={{
            width: "100%", padding: "14px",
            borderRadius: 14,
            border: "1px solid rgba(255,255,255,0.1)",
            background: "rgba(255,255,255,0.04)",
            color: "rgba(255,255,255,0.55)", fontSize: 14, fontWeight: 600,
            cursor: "pointer", fontFamily: "inherit",
          }}
        >
          Prefiro pagar ao final da corrida
        </button>
      </div>
    </div>
  );
}
